/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_File_HelpInputs */



/**
* | output |
* | --- |
* | "Select a JSON or EDL file containing markers" |
*
* @param {Marker_Import_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_file_help = /** @type {((inputs?: Marker_Import_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un fichier JSON ou EDL contenant des marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine JSON- oder EDL-Datei mit Markierungen aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file JSON o EDL contenente i marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл JSON или EDL, содержащий маркеры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo JSON o EDL que contenga marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择包含标记的 JSON 或 EDL 文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを含むJSONまたはEDLファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर युक्त JSON या EDL फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um arquivo JSON ou EDL contendo marcadores.")
	return /** @type {LocalizedString} */ ("Select a JSON or EDL file containing markers")
});